import styled from 'styled-components';

const ButtonRow = styled.div`
  display: block;
  margin-top: ${({theme}) => theme.spacingVertical()};
`;

export default ButtonRow;
